import React from 'react';
import PropTypes from 'prop-types';

import withStyles from '@material-ui/core/styles/withStyles';

import SpeedDial from './SpeedDial';
import { SpeedDialAction } from '@material-ui/lab';

import {
    DrawIcon
} from '../Icons';

import {
    PointIcon,
    LineIcon,
    PolygonIcon,
    TrashIcon,
    CircleIcon,
    ExtrudeIcon
} from '../Draw/Icons';


class DrawControl extends React.PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        draw: PropTypes.object
    };

    constructor (props) {
        super(props);

        this.state = {

        };
    }

    render () {
        const { classes, draw } = this.props;
        return (
            <SpeedDial
                label={'Draw Tools'}
                icon={<DrawIcon />}
            >
                <SpeedDialAction
                    icon={<TrashIcon />}
                    tooltipTitle={'Delete Tool'}
                    onClick={() => draw && draw.drawControl.trash()}
                />
                <SpeedDialAction
                    icon={<ExtrudeIcon />}
                    tooltipTitle={'Extrude Tool'}
                    onClick={() => draw && draw.changeMode(draw.drawControl.modes.EXTRUDE_MODE,
                        { featureIds: draw.drawControl.getSelectedIds() })}
                />
                <SpeedDialAction
                    icon={<CircleIcon />}
                    tooltipTitle={'Draw Circle Tool'}
                    onClick={() => draw && draw.changeMode(draw.drawControl.modes.DRAW_CIRCLE)}
                />
                <SpeedDialAction
                    icon={<PolygonIcon />}
                    tooltipTitle={'Draw Area Tool'}
                    onClick={() => draw && draw.changeMode(draw.drawControl.modes.DRAW_POLYGON)}
                />
                <SpeedDialAction
                    icon={<LineIcon />}
                    tooltipTitle={'Draw Line & Measurement Tool'}
                    onClick={() => draw && draw.changeMode(draw.drawControl.modes.DRAW_LINE_STRING)}
                />
                <SpeedDialAction
                    icon={<PointIcon />}
                    tooltipTitle={'Marker Tool'}
                    onClick={() => draw && draw.changeMode(draw.drawControl.modes.DRAW_POINT)}
                />
            </SpeedDial>
        );
    }
}

const style = theme => ({

});

export default withStyles(style)(DrawControl);